import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currency',
  standalone: true
})
export class CurrencyPipe implements PipeTransform {

  private readonly locale: string = 'pt-BR';
  private readonly currencySymbol: string = 'R$ ';
  private readonly fractionDigits: number = 2;

  transform(value: number | string): string {
    if (value == null || value === '') return '';

    // Garantir que o valor seja numérico
    const numericValue = typeof value === 'string' ? parseFloat(value) : value;

    if (isNaN(numericValue)) return '';

    const options = { minimumFractionDigits: this.fractionDigits };
    const formatted = new Intl.NumberFormat(this.locale, options).format(
      numericValue
    );

    return this.currencySymbol + formatted;
  }
}
